module.exports = __webpack_public_path__ + "static/media/static-es.f46f017c.png";